module.exports = __webpack_public_path__ + "static/img/login_bg.0eee311.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/ecshopx/login_bg.jpg
// module id = 936
// module chunks = 30